import { Download, Edit3, File, Lock, Trash2, Unlock, UploadCloud } from "react-feather";
import { useContext } from "react";
import { SettingsContext } from "../../../../infrastructure/SettingsContext";
import { useNavigate } from "react-router-dom";
import { ButtonWithText } from "./ButtonWithText";

import "./ArticleToolbar.css";

export const ArticleToolbar = ({
    onClickPublish,
    articleId,
    onLockClick,
    onDeleteClick,
    onDownloadClick,
    isLocked,
    viewMode,
    onViewModeChange,
}) => {
    const { settings } = useContext(SettingsContext);
    const navigate = useNavigate();

    return (
        <div className="toolbar">
            {articleId > 0 && (
                <>
                    <button
                        className={"btn btn-primary" + (isLocked ? " disabled" : "")}
                        disabled={isLocked}
                        onClick={(e) => {
                            navigate(`/articles/${articleId}/edit`);
                        }}
                    >
                        <span className="text-icon">
                            <Edit3 size={18} />
                            <div>Edit</div>
                        </span>
                    </button>
                    <ButtonWithText onClick={onDeleteClick}>
                        <span className="text-icon">
                            <Trash2 />
                            <div onClick={onDeleteClick}>Delete</div>
                        </span>
                    </ButtonWithText>
                    <ButtonWithText onClick={onLockClick}>
                        <span className="text-icon">
                            {isLocked ? <Unlock /> : <Lock />}
                            <div>{isLocked ? "Unlock" : "Lock"}</div>
                        </span>
                    </ButtonWithText>
                    {onViewModeChange && (
                        <button
                            className="btn btn-primary"
                            onClick={() => onViewModeChange(viewMode === "pdf" ? "plain" : "pdf")}
                        >
                            <span className="text-icon">
                                <File size={18} />
                                <div>{viewMode === "pdf" ? "Plain" : "PDF Style"}</div>
                            </span>
                        </button>
                    )}
                    <ButtonWithText onClick={onDownloadClick}>
                        <span className="text-icon">
                            <Download />
                            <div>Download</div>
                        </span>
                    </ButtonWithText>
                    <button
                        className={"btn btn-primary" + (settings && settings.PUBLISH_ENABLED ? " disabled" : "")}
                        disabled={settings && !settings.PUBLISH_ENABLED}
                        onClick={(e) => {
                            if (onClickPublish) {
                                onClickPublish(e);
                            }
                        }}
                    >
                        <span className="text-icon">
                            <UploadCloud />
                            <div>Publish</div>
                        </span>
                    </button>
                </>
            )}
        </div>
    );
};
